import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchBlogById } from '../api/blogs';
import { API_BASE_URL } from '../utils/constants';

const BlogPostDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadBlog = async () => {
      try {
        const data = await fetchBlogById(id);
        setBlog(data);
      } catch (err) {
        console.error(err);
        setError('Blog post not found.');
      } finally {
        setLoading(false);
      }
    };
    loadBlog();
  }, [id]);

  if (loading) {
    return (
      <div className="px-6 py-10 max-w-3xl mx-auto">
        <p className="text-gray-500">Učitavanje blog posta...</p>
      </div>
    );
  }

  if (error || !blog) {
    return (
      <div className="px-6 py-10 max-w-3xl mx-auto">
        <p className="text-red-600">{error || 'Blog post not found.'}</p>
        <Link
          to="/blog"
          className="inline-block mt-4 text-sm text-indigo-600 hover:underline"
        >
          ← Nazad na blog
        </Link>
      </div>
    );
  }

  return (
    <div className="px-6 py-10 max-w-3xl mx-auto">
      {/* Back link */}
      <Link
        to="/blog"
        className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-indigo-600 mb-6"
      >
        <span>←</span>
        <span>Nazad na blog</span>
      </Link>
      <h1 className="text-3xl font-bold mb-2">{blog.title}</h1>
      {blog.date && (
        <p className="text-sm text-gray-500 mb-6">{blog.date}</p>
      )}
      {blog.image && (
        <div className="mb-8 rounded-xl overflow-hidden shadow-sm bg-gray-100">
          <img
            src={`${API_BASE_URL}/uploads/blogs/${blog.image}`}
            alt={blog.title}
            className="w-full h-64 md:h-80 object-cover"
          />
        </div>
      )}
      <div
        className="mt-4 leading-relaxed text-gray-800 blog-content"
        dangerouslySetInnerHTML={{ __html: blog.content }}
      />
    </div>
  );
};

export default BlogPostDetail;
